import { createFileRoute } from "@tanstack/react-router";
import Implementation from "@/pages/Implementation";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/implementation")({
  head: () => pageHead("/implementation", "zh"),
  component: Implementation,
});
